jQuery(function($) {
    'use strict';

    var AppForm = function() {
    }

    AppForm.prototype.init = function() {
        $(document).on('click', '.btn-number', function() {
            var type = $(this).data('type');

            var $group = $(this).closest('.input-group-number');
            var $input = $group.find('.input-number');
            var value = parseFloat($input.val());

            var step = $input.attr('step') ? parseFloat($input.attr('step')) : 1;
            var min = $input.attr('min') ? parseFloat($input.attr('min')) : 0;
            var max = $input.attr('max') ? parseFloat($input.attr('max')) : 1000;

            if(type == 'minus'&&value > min) {
                $input.val(value - step);
            } else if(type == 'plus'&&value < max) {
                $input.val(value + step);
            }

            $input.trigger('change');
        });
    }

    AppForm.prototype.unserialize = function(array) {
        var jsonObj = {};
        jQuery.map(array, function(n, i) {
            jsonObj[n.name] = n.value;
        });

        return jsonObj;
    }

    $.AppForm = new AppForm;
    $.AppForm.Constructor = AppForm;
});

jQuery(function($) {
    'use strict';

    $.AppForm.init();
});
